import { AccountInfo, IPublicClientApplication } from "@azure/msal-browser";

export class MsalContextHelper {

    /* Members */
    instance: IPublicClientApplication;

    /**
     * CTOR
     * @param instance : Inject MSAL Client Application
     */
    constructor(instance: IPublicClientApplication)
    {
        this.instance = instance;
    }

    /**
     * Retrieves the current username from the msal web context | active instance.
     * @returns
     */
    getCurrentUserName(): string | null {

        let activeAccount: AccountInfo | null = this.instance.getActiveAccount();
        if (activeAccount == null)
        {
            return null;
        }

        return activeAccount.username;
    }

    /**
     * Retrieves all actives roles that are assigned to the current logged in user
     * @returns All active roles for current user.
     */
    getRoles() : string[] {

        let activeAccount: AccountInfo | null = this.instance.getActiveAccount();
        if (activeAccount == null)
        {
            return [];
        }

        return activeAccount.idTokenClaims?.roles ?? [];
    }

    /**
     * Method checks if current user has a specific role assigned.
     * @param roleName Role that needs to be checked
     * @returns Boolean if role is assigned to current user.
     */
    hasRole(roleName: string) {

        return this.hasAnyRole(roleName);
    }

    /**
     * Method checks if current user has any of the listed roles assigned.
     * @param roleNames Roles that needs to be checked
     * @returns Boolean
     */
    hasAnyRole(...roleNames : string[]): boolean {

        let roles: string[] = this.getRoles();
        let result: boolean = false;

        roleNames.forEach(role =>
        {
            if (roles.includes(role))
            {
                result = true;
                return;
            }
        })

        return result;
    }
}